import { useCallback } from 'react';

import DropDownButton from 'my-elements/DropDownButton';

import ToolbarButton from './ToolbarButton';

const ANCHOR_ORIGIN_DEFAULT = { horizontal: 'right', vertical: 'top' };
const TRANSFORM_ORIGIN_DEFAULT = { horizontal: 'left', vertical: 'top' };
export default function ToolbarDropDownButton({
  anchorOrigin = ANCHOR_ORIGIN_DEFAULT,
  children,
  icon,
  menu,
  PaperProps,
  ToolbarButtonProps,
  tooltip,
  transformOrigin = TRANSFORM_ORIGIN_DEFAULT,
}) {
  // preventDefault so 'click' isn't triggered, causing focus to change
  const preventDefaultEvent = useCallback(e => e.preventDefault(), []);

  return (
    <DropDownButton
      anchorOrigin={anchorOrigin}
      button={
        <ToolbarButton tooltip={tooltip} {...ToolbarButtonProps}>
          {icon}
        </ToolbarButton>
      }
      css={({ zIndex }) => ({ zIndex: `${zIndex.modal + 2} !important` })}
      menu={menu}
      mouseEvent="onMouseDown"
      onMouseDown={e => {
        e.preventDefault(); // prevent focus leaving editor
        e.stopPropagation(); // prevent EquationEditor ClickAway from handling this and immediate closing.
      }}
      slotProps={{
        backdrop: { onMouseUp: preventDefaultEvent, invisible: true },
        paper: {
          onMouseUp: preventDefaultEvent,
          onMouseDown: preventDefaultEvent,
          ...PaperProps,
        },
      }}
      transformOrigin={transformOrigin}
      {...MODAL_PROPS}
    >
      {children}
    </DropDownButton>
  );
}

const MODAL_PROPS = {
  disableAutoFocus: true,
  disableEnforceFocus: true,
  disableRestoreFocus: true,
};
